export const DETAIL_COLUMNS = {
  VIEW_DETAIL: 'View Details',
  VIEW_HISTORY: 'View History',
};
